import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetDeviceTypes = ApiClient['v1']['device-types']['$get'];
type DeviceTypeListQuery = InferRequestType<GetDeviceTypes>['query'];
export type DeviceTypeListResponse = InferResponseType<GetDeviceTypes, 200>;
export type DeviceType = DeviceTypeListResponse['deviceTypes'][number];

export function useDeviceTypes(params: DeviceTypeListQuery = {}) {
  return useFetch<DeviceTypeListResponse>(
    `device-types?${JSON.stringify(params)}`,
    (client) => client.v1['device-types'].$get({ query: params }),
    undefined,
    { keepPreviousData: true }
  );
}
